<template>
  <client-only>
    <noscript v-if="false">
      <p>JavaScript is disabled. Please enable it for a better experience.</p>
    </noscript>
  </client-only>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
